module.exports = __webpack_public_path__ + "img/the-footnotes-jazz-collective.f20cf74d.png";